/**
 * Links into the rrecce web app, which owns sign-in, sign-up, the settings pages and the Vision
 * dashboard. This app is served at `<web app base>vision/` on the same origin, so the web app's
 * base is this app's base without its last segment.
 */

export function webAppBase() {
  return import.meta.env.BASE_URL.replace(/vision\/$/, '').replace(/\/$/, '');
}

function webUrl(path, search) {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(search ?? {})) {
    if (value != null && value !== '') query.set(key, String(value));
  }
  const queryString = query.toString();
  return `${webAppBase()}${path}${queryString === '' ? '' : `?${queryString}`}`;
}

// Must match the `notice` values the web dashboard route accepts
export const DashboardNotice = Object.freeze({
  ACCESS_REMOVED: 'access_removed',
  PROJECT_GONE: 'project_gone',
  PROJECT_UNAVAILABLE: 'project_unavailable',
  PROJECT_DELETED: 'project_deleted',
  LEFT_PROJECT: 'left_project',
  OWNERSHIP_TRANSFERRED: 'ownership_transferred',
});

export function webDashboardUrl(notice) {
  return webUrl('/dashboard', { notice });
}

export function webSettingsUrl() {
  return webUrl('/settings');
}

export function webProfileUrl() {
  return webUrl('/profile');
}

export function webLoginUrl(returnTo) {
  return webUrl('/login', { returnTo });
}

export function webSignupUrl({ returnTo, email } = {}) {
  return webUrl('/signup', { returnTo, email });
}

export function webReactivateUrl(returnTo) {
  return webUrl('/reactivate-account', { returnTo });
}

// The document path of one of this app's router paths: the Vite base the router strips is put
// back in front
export function visionPath(routerPath) {
  return `${import.meta.env.BASE_URL.replace(/\/$/, '')}${routerPath}`;
}

export function currentVisionPath() {
  return window.location.pathname + window.location.search;
}

export function openInWebApp(url) {
  window.location.assign(url);
}

// A replace, so Back does not land on the page that sent the visitor away
export function replaceWithWebApp(url) {
  window.location.replace(url);
}
